module.exports = "0.29.0";



//////////////////
// WEBPACK FOOTER
// /builds/BootPM/classic.yarnpkg.cn/node_modules/autocomplete.js/version.js
// module id = ../../node_modules/autocomplete.js/version.js
// module chunks = 6